import { useEffect } from 'react';
import dynamic from 'next/dynamic';
import Flex from '@deprecated-ui/common/Flex';
import Tooltip from '@deprecated-ui/watchlist/Tooltip';
import ConnectionIndicator from '@deprecated-ui/watchlist/ConnectionIndicator';
import { useDispatch, useSelector } from 'react-redux';
import auth from 'utils/auth';
import { Box } from './styled';
import Collection from './Collection';
import { selectors as selectorMarket } from 'global/MainLayout/slice';
import slice, { selectors } from './slice';

const WatchlistTable = dynamic(() => import('./WatchlistTable'), {
  ssr: false,
});

const { actions } = slice;

function Watchlist() {
  // @ts-ignore
  const { activeWatchlistId, connectionStatus, isExpand, isComposed } =
    useSelector(selectors);
  const dispatch = useDispatch();

  const { isSideWidgetOpen } = useSelector(selectorMarket);

  useEffect(() => {
    // @ts-ignore
    const { watchlist_id: wl } = auth.getUserAccess();
    dispatch(
      actions.handleChangeActiveWatchlist({
        selected: wl,
        name: 'All Watchlist',
      }),
    );
  }, [dispatch]);

  let containerWidth = isSideWidgetOpen ? '100%' : '990px';

  if (isComposed) {
    containerWidth = '798px';
  } else if (isExpand) {
    containerWidth = '100%';
  }

  return (
    <>
      {/* @ts-expect-error */}
      <Flex direction="column" width={containerWidth} m="auto" mt="3px">
        <Box
          justify="space-between"
          align="center"
          // @ts-expect-error
          p="15px 12px"
          width="100%"
        >
          <Collection />
          <Tooltip
            title={`Connection Status: ${connectionStatus}`}
            placement="left"
          >
            <ConnectionIndicator isConnected={connectionStatus} size="small" />
          </Tooltip>
        </Box>
        {/* @ts-expect-error */}
        <Box direction="column" my="16px" width="100%">
          {activeWatchlistId && <WatchlistTable />}
        </Box>
      </Flex>
    </>
  );
}

export default Watchlist;
